import { render } from "./loader.vue?vue&type=template&id=e29bb1ee&scoped=true"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=e29bb1ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29bb1ee"]])

export default __exports__